import { Filter } from '@anytag/shared-molecules';
import { useThreadsInfluencersContext } from '../ThreadsInfluencersContext';
import { BasicFilter } from './BasicFilter';

export const ThreadsInfluencersFilter = () => {
  const { filter, setFilter, isEngagementPage, isPackagePage } = useThreadsInfluencersContext();

  return (
    <Filter.Provider onSubmit={setFilter} values={filter} className="rounded-none">
      <BasicFilter isEngagementPage={isEngagementPage} isPackagePage={isPackagePage} />
    </Filter.Provider>
  );
};
